import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setSceneDescriptionState } from '../store/sceneDescription.actions'

export function* getSceneDescription(pcrDoc: IPcr) {
  const sceneDescription = pcrDoc.sceneDescription
  if (sceneDescription && Object.keys(sceneDescription).length !== 0) {
    yield put(setSceneDescriptionState(sceneDescription))
  }
}
